import { render, staticRenderFns } from "./QuotaUsageSummary.vue?vue&type=template&id=283aa3ec"
import script from "./QuotaUsageSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotaUsageSummary.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports